<script>
import { mapState, mapGetters } from "vuex";
import gsap from "gsap";
import ScrollTo from "gsap/ScrollToPlugin";
import _ from "lodash";

// components
import HeroBanner from "./components/HeroBanner.vue";
import UtilityNav from "./components/UtilityNav.vue";
import AppSection from "./components/AppSection.vue";
import AppModal from "./components/AppModal.vue";

// import TwoColsSameHeight from "./components/TwoColsSameHeight.vue";

gsap.registerPlugin(ScrollTo);

export default {
  props: {
    content: {
      required: true,
    },
  },
  components: {
    HeroBanner,
    UtilityNav,
    AppSection,
    AppModal,
    // TwoColsSameHeight,
  },
  methods: {
    scrollToSection() {
      gsap.to(window, {
        duration: 0.7,
        scrollTo: "#walls",
        ease: "power4.out",
      });
    },
  },
  computed: {
    //...mapState(useLaunchStore, ["pageTitle", "utilityNav", "sections"]),
    ...mapState(["modalAttr"]),

    ...mapGetters(["utilityNav", "sections"]),
  },
  mounted() {},

  created() {
    this.$store.dispatch("setContent", this.content);
  },
};
</script>

<template>
  <div class="">
    <transition name="fade" appear>
      <AppModal v-if="modalAttr.isModalOpen" />
    </transition>
    <HeroBanner />

    <UtilityNav :content="utilityNav" />
    <AppSection
      v-if="
        section.id != 'baner1' &&
          section.id != 'baner2' &&
          section.id != 'baner3' &&
          section.id != 'baner44'
      "
      v-for="(section, index) in sections"
      :key="section.id"
      :content="section"
      :section-index="index"
    />
  </div>
</template>

<style lang="scss">
body {
  padding: 0;
  margin: 0;
}

:root {
  --left-bleed-width: 100px;
  --layout-grid-gap: 30px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.topSection {
  height: 100vh;
  background: hsla(241, 24%, 79%, 1);
}

h1 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/App.vue